import React from 'react';
import { Link } from 'react-router-dom';

import IconMultiples from '../../../../../assets/images/icons/misc/icon-multiples.svg';
import style from './ZeroRestricted.module.scss';

const ZeroRestricted = () => (
  <div className={style.main}>
    <IconMultiples />
    <span>
      Multiples are only available on
      <br />
      Matchbook Exchange at this time
    </span>
    <Link
      to="/"
    >
      GO TO MATCHBOOK EXCHANGE
    </Link>
  </div>
);

export default ZeroRestricted;
